import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CwGapiService } from '../../services/cw-gapi.service';

@Injectable()
export class CWGapiInterceptor implements HttpInterceptor {
  token: string | null;

  // **NOTE: This interceptor is only loaded for gapi... so only adds additional headers to the headers already added in token.interceptor
  constructor(private cwGapiService: CwGapiService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req.clone();

    if (req.url.search('api') !== -1) {
      this.token = sessionStorage.getItem('gapi_token');

      if (this.token && this.tokenExpired(this.token)) {
        this.cwGapiService.reloadAuth();
        this.token = sessionStorage.getItem('gapi_token');
      }

      if (this.token) {
        this.showtokenExpiry(this.token);
        authReq = req.clone({
          setHeaders: {
            Authorization: 'Bearer ' + this.token,
          },
        });
      }
    }

    return next.handle(authReq).pipe(
      catchError(error => {
        return throwError(error);
      })
    );
  }

  private tokenExpired(token: string | null): boolean {
    if (!token || token.split('.').length < 2) return true;
    try {
      const expiry = JSON.parse(atob(token.split('.')[1])).exp;
      return Math.floor(new Date().getTime() / 1000) >= expiry;
    } catch {
      return true;
    }
  }

  private showtokenExpiry(token: string | null): void {
    if (!token || token.split('.').length < 2) return;
    try {
      const expiry = JSON.parse(atob(token.split('.')[1])).exp;
      const d = new Date(0);
      d.setUTCSeconds(expiry);
    } catch {}
  }
}
